import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, Label } from "@headlessui/react";
import { FaCheck, FaRegCircleCheck, FaRegCircleXmark } from "react-icons/fa6";
import { RiArrowDownSLine } from "react-icons/ri";
import { forwardRef, useImperativeHandle, useState } from "react";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const MultipleSelectDropDown = forwardRef(({ options, onChange }, ref) => {
    const [selectedFields, setSelectedFields] = useState([]);
    const [query, setQuery] = useState("");
    const [open, setOpen] = useState(false);

    const isSelectAllEnabled = selectedFields.length < options.length;
    const isClearSelectionEnabled = selectedFields.length > 0;

    useImperativeHandle(ref, () => ({
        clearSelectedFields() {
            handleOnClearOptions();
        },
    }));

    const handleSelectionChange = (fields) => {
        console.log("handleSelectionChange=>", fields);
        setSelectedFields(fields);
        setQuery("");
        if (onChange) {
            onChange(fields);
        }
    };

    const handleSelectAllClick = () => {
        setSelectedFields(options);
        if (onChange) {
            onChange(options);
        }
    };

    const handleOnClearOptions = () => {
        setSelectedFields([]);
        if (onChange) {
            onChange([]);
        }
    };

    const filteredOptions = options.filter((option) => option.name.toLowerCase().includes(query.toLowerCase()));

    const selectedFieldsString = selectedFields.map((f) => f.name).join(", ");

    const isSelectedField = (field) => selectedFields.some((f) => f.id === field.id);

    return (
        <Combobox multiple as={"div"} value={selectedFields} onChange={handleSelectionChange} className="mt-2">
            <div className="relative">
                <ComboboxInput
                    className="w-full rounded border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue_ncs sm:text-sm sm:leading-6"
                    onChange={(event) => {
                        console.log("event", event);
                        setQuery(event.target.value);
                    }}
                    onBlur={() => {
                        setQuery("");
                        setOpen(false);
                    }}
                    readOnly
                    onFocus={() => {
                        // console.log("ON FOCUS INPUT ==> ");
                        setOpen(true);
                    }}
                    displayValue={() => selectedFieldsString}
                />
                <ComboboxButton
                    className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none"
                    // onClick={() => setOpen(!open)}
                >
                    <RiArrowDownSLine className="h-5 w-5 text-gray-400" aria-hidden="true" />
                </ComboboxButton>
                {open && filteredOptions.length > 0 && (
                    <ComboboxOptions className="absolute z-50 max-h-60 w-full overflow-auto rounded-md bg-white text-base shadow-lg ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                        <div className="flex w-full justify-between py-3 px-2  bg-gray-200">
                            <button
                                className="inline-flex items-center font-medium shadow-sm border rounded-sm border-blue-500 text-sm text-gray-700 px-2 py-1 hover:text-gray-900 hover:font-semibold disabled:font-normal disabled:cursor-not-allowed"
                                onClick={handleSelectAllClick}
                                disabled={!isSelectAllEnabled}
                            >
                                전체 선택
                            </button>
                            <button
                                className="inline-flex items-center px-2 py-1 shadow-sm border rounded-sm border-blue-500  text-gray-700  hover:text-gray-900 hover:font-semibold disabled:font-normal disabled:cursor-not-allowed"
                                disabled={!isClearSelectionEnabled}
                                onClick={handleOnClearOptions}
                            >
                                선택 해제
                            </button>
                        </div>
                        {filteredOptions.map((field) => (
                            <ComboboxOption
                                key={field.id}
                                value={field}
                                onChange={(event) => setQuery(event.target.value)}
                                className={({ focus }) =>
                                    classNames(
                                        "relative cursor-default select-none py-2 pl-3 pr-9",
                                        focus ? "bg-blue-100" : isSelectedField(field) ? "bg-slate-100" : "text-gray-900"
                                    )
                                }
                            >
                                {({ focus }) => (
                                    <>
                                        <span className={classNames("block truncate ", isSelectedField(field) && "font-bold ")}>
                                            {field.name}
                                        </span>
                                        {isSelectedField(field) && (
                                            <span
                                                className={classNames(
                                                    "absolute inset-y-0 right-0 flex items-center pr-4",
                                                    focus ? "text-white" : "text-indigo-600"
                                                )}
                                            >
                                                <FaCheck className="h-5 w-5" aria-hidden="true" />
                                            </span>
                                        )}
                                    </>
                                )}
                            </ComboboxOption>
                        ))}
                    </ComboboxOptions>
                )}
            </div>
        </Combobox>
    );
});

export default MultipleSelectDropDown;
